// extracted by mini-css-extract-plugin
export default {"info":"_3Z7Dt","time":"_20TrA","title":"_1ZrmI","ellipsis":"_2JWmA","more":"_3BXl3"};